import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import { AccountantAffectedStaffSalariesListPage } from './accountant-affected-staff-salaries-list'
import { AccountantMissionTrackingSalariesListPage } from './accountant-mission-tracking-salaries-list'

const accountantPersonalSpaceRoutes: Route[] = [
  {
    path: Paths.ACCOUNTANT_PERSONAL_SPACE_AFFECTED_STAFFS_SALARIES_LIST_PAGE,
    element: <AccountantAffectedStaffSalariesListPage />,
    roles: [RoleEnum.ACCOUNTANT, RoleEnum.ADMIN]
  },
  {
    path: Paths.ACCOUNTANT_PERSONAL_SPACE_MISSION_TRACKINGS_SALARIES_LIST_PAGE,
    element: <AccountantMissionTrackingSalariesListPage />,
    roles: [RoleEnum.ACCOUNTANT, RoleEnum.ADMIN]
  }
]

export default accountantPersonalSpaceRoutes
